import * as React from "react";
import './XRay.scss';
import {XRayController, XRayLocation} from "../../../Controller/3DController/XRayController";
import { Battery, Car, CarBack, ChevronLeft, ChevronRight, Close, Seats } from '../Icons/Icons';


interface Props{
    xRayController:XRayController;
    exit:()=>void
}

interface State{
    location:XRayLocation;
}

export class XRay extends React.Component<Props,State> {

    constructor(props:Props){
       super(props);
       this.state = {
           location: this.props.xRayController.location
       }
    }

    componentDidMount(){
        this.setLocation(XRayLocation.Car);
        this.forceUpdate();
    }

    componentWillUnmount(){
    }

    setLocation(location:XRayLocation):void {
        this.props.xRayController.setLocation(location);
        this.updateLocationUI();
    }

    updateLocationUI():void {
        this.setState({
            location: this.props.xRayController.location
        });
    }

    renderCricleButton(active: boolean, icon: React.ReactElement, opt? :any) {
        let {_class, onClick} = opt;
        return (
            <div
                className={`vw-xray-menu__option-menu-item ${active ? 'selected' : ''}`}
                onClick={ onClick }
            >
                {icon}
            </div>
        );
    }

    renderArrow(left:boolean, onClick: any) {
        return(
            <div className="vw-xray-menu__bottom-menu-button" onClick={onClick}>
                {left ? <ChevronLeft /> : <ChevronRight />}
            </div>
        );
    }

    renderXRayButton(location:XRayLocation, icon: React.ReactElement) {
        return this.props.xRayController.isEnabledLocation(location) && this.renderCricleButton(
            this.state.location === location,
            icon,
            {
                _class: "xray-button",
                onClick: () => {
                    this.setLocation(location);
                }
            }
        )
    }

    render(){
        return(
            <div className="vw-xray-menu">
                <div className="vw-xray-menu__option-menu">
                    {
                        [
                            this.renderXRayButton(XRayLocation.Car, <Car />),
                            this.renderXRayButton(XRayLocation.Seat, <Seats />),
                            this.renderXRayButton(XRayLocation.Battery, <Battery />),
                            this.renderXRayButton(XRayLocation.Trunk, <CarBack />)
                        ]
                    }
                </div>

                <div className="vw-xray-menu__bottom-menu">
                    {this.renderArrow(true, () => {
                        this.props.xRayController.rotateLeft();
                        this.updateLocationUI();
                    })}

                    <div
                        className="vw-xray-menu__bottom-menu-button exit"
                        onClick={this.props.exit}
                    >
                        <Close />
                    </div>

                    {this.renderArrow(false, () => {
                        this.props.xRayController.rotateRight();
                        this.updateLocationUI();
                    })}
                </div>
            </div>
        )
    }
}
